import { render, staticRenderFns } from "./CompanyMailingAddress.vue?vue&type=template&id=48bdf6ad"
import script from "./CompanyMailingAddress.vue?vue&type=script&lang=js"
export * from "./CompanyMailingAddress.vue?vue&type=script&lang=js"
import style0 from "./CompanyMailingAddress.vue?vue&type=style&index=0&id=48bdf6ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports